<div class="layout-footer">
  <div class="flex flex-row text-neutral-400 dark:text-neutral-400">
    <img class="grayscale h-5 mr-2" src="/assets/icons/icon-512x512.png" alt="oskaru o" />
    oskaru.net PWA v{{appVersion}}
  </div>
</div>
